/**
 * @fileoverview GET handler for the "/alloys/gemini/agentic/:app_group_id/oauth/verify_project" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysGeminiAgenticAppGroupIdOauthVerifyProject } from "./constants";
import type { GetAlloysGeminiAgenticOauthVerifyProjectResult } from "./types";
import { isGetAlloysGeminiAgenticOauthVerifyProjectResult } from "./validators";

export const getAlloysGeminiAgenticAppGroupIdOauthVerifyProject = reactQueryFetcherAdapter(
  alloysGeminiAgenticAppGroupIdOauthVerifyProject,
  (
    signal: AbortSignal,
    appGroupId: string,
    projectId: string
  ): Promise<GetAlloysGeminiAgenticOauthVerifyProjectResult> => {
    return fetch(
      `/alloys/gemini/agentic/${appGroupId}/oauth/verify_project?project_id=${encodeURIComponent(projectId)}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysGeminiAgenticOauthVerifyProjectResult
);
